export default {
  title: 'Kassen',
};
